import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Picker } from './Picker';
export const MonthPicker = ({ label = 'Month', placeHolder = 'Please Select Month', ...props }) => {
    const monthItems = useMemo(() => {
        const monthNames = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ];
        const months = new Array(12)
            .fill(1)
            .map((month, index) => month + index);
        months.unshift(undefined);
        return months.map((month) => {
            return month === undefined
                ? {
                    label: placeHolder,
                    value: undefined,
                }
                : {
                    label: monthNames[month - 1],
                    value: month,
                };
        });
    }, []);
    return _jsx(Picker, { ...props, items: monthItems, label: label });
};
